export const MASQUERADE_PARTNER_ID_KEY = 'masqueradePartnerId'
